<header-home-page></header-home-page>

<div style="margin-top: 30px;">
  <iframe src="./assets/params/html/Smart Portfolio.html" title="description" style="width: 100vw; height: 100vh;"></iframe>
</div>